import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdOrderDraftState, AdOrderItemDraft } from '../reducers/ad-order-draft.reducer';

// Шаг 1: Создаем Feature Selector для состояния AdOrderDraftState
export const selectAdOrderDraftState = createFeatureSelector<AdOrderDraftState>('adOrderDraft');

// Шаг 2: Создаем селектор для получения списка элементов заказа
export const selectAdOrderItems = createSelector(
  selectAdOrderDraftState,
  (state: AdOrderDraftState) => state.adOrderItems
);

// Создаем селектор для получения общей цены
export const selectTotalPrice = createSelector(
  selectAdOrderDraftState,
  (state: AdOrderDraftState) => state.totalPrice
);

// Создаем селектор для получения публикации
export const selectAdPublication = createSelector(
  selectAdOrderDraftState,
  (state: AdOrderDraftState) => state.adPublication
);

// Селектор для проверки, добавлена ли платформа в AdOrderDraft
export const isPlatformAddedToAdOrderDraft = (platformId: number) =>
  createSelector(
    selectAdOrderItems,
    (orderItems: AdOrderItemDraft[]) => orderItems.some(item => item.platform.id === platformId)
  );
